<template>
    <div>
        <div
            class="share-favorite d-flex flex-column"
            :class="{'plot-counter-translate': $vuetify.breakpoint.smAndUp}"
        >
            <h2 class="font-weight-bold text-truncate">
                {{ $t('favorite.wishlist') }}
            </h2>

            <!-- Activator -->
            <v-btn
                class="share-favorite-cta text-none pl-1 habiteo-body-2 font-weight-bold justify-start"
                :class="{'justify-start': $vuetify.breakpoint.mdAndUp}"
                text
                block
                x-small
                :ripple="false"
                @click.prevent="dialog = true"
            >
                <v-icon left>
                    icon-share
                </v-icon>
                {{ $t('share.share') }}
            </v-btn>
            <!-- /Activator -->
        </div>
        
        <!-- /Dialog -->
        <v-dialog
            class="share-favorite-dialog"
            v-model="dialog"
            width="320px"
        >
            <v-card>
                <v-toolbar flat>
                    <h2 class="pl-3 font-weight-regular">
                        {{ $t('share.share') }}
                    </h2>
                    <v-spacer/>
                    <v-toolbar-items>
                        <v-btn
                            text
                            @click="dialog = false"
                        >
                            <v-icon>
                                mdi-close
                            </v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <div class="d-flex share-favorite-link">
                        <div
                            id="urlToCopy"
                            class="pa-2 text-truncate"
                        >
                            {{ widgetLink }}
                        </div>

                        <v-btn
                            id="gtm-header-share-favorite"
                            text
                            class="text-none copy-cta font-weight-bold"
                            @click="copyLink()"
                        >
                            {{ $t('share.copyLink') }}
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- /Dialog -->
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: "ShareFavorite",
        computed: {
            ...mapGetters([
                'isLocalstorageAvailable'
            ]),
            widgetLink() {
                let shareLink = new URL(window.location.href);
                shareLink.searchParams.set('favlist', this.favoriteList.join(','));
                return shareLink.href;
            },
            favoriteKey() {
                return `favorite-${this.$route.query.id}`;
            },
            favoriteList() {
                return this.isLocalstorageAvailable && localStorage.getItem(this.favoriteKey) ? JSON.parse(localStorage.getItem(this.favoriteKey)) : null;
            }
        },
        data: () => ({
            dialog: false
        }),
        props: {
            widget: {
                type: String,
                required: true
            }
        },
        methods: {
            ...mapActions([
                'setSnackbar'
            ]),
            copyLink() {
                let range = document.createRange();
                range.selectNode(document.getElementById("urlToCopy"));
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                document.execCommand("copy");
                window.getSelection().removeAllRanges();

                this.dialog = false;

                this.setSnackbar({
                    'message': this.$t('share.copy'),
                    'orientation': 'top'
                });
            }
        }
    }
</script>

<style lang="scss">
    @import '@/assets/scss/components/_share-favorite.scss';
</style>


// WEBPACK FOOTER //
// src/components/cutawayHeader/components/ShareFavorite.vue